import React, { useEffect, useState } from "react";
import { Roles } from "../firestore/Types/PermissionSchema";
import { useAuth } from "../contexts/auth/AppAuthContext";
import { useNavigate } from "react-router-dom";
import { AccountSchema, nameofAccountSchemaDOB, nameofAccountSchemaFirstName, nameofAccountSchemaLastName, nameofAccountSchemaMiddleName, nameofAccountSchemaPhoneNumber } from "../firestore/Types/AccountSchema";
import { useUtility } from "../contexts/auth/UtilityContext";
import { SchoolTag } from "../components/SchoolTag";
import { CreateTutorAccount, CreateUserAccount } from "../firestore/Functions/accountFunctions";
import { Textbox } from "../components/Common/Textbox";
import { DateBox } from "../components/Common/DateBox";

export function SetupAccount() {
    const { userLoggedIn, permission, account, refreshAccount } = useAuth();

    const navigate = useNavigate();

    const { schools, schoolImages, setNewToast } = useUtility();

    const [page, setPage] = useState(0);

    const [accountFilled, setAccountFilled] = useState(false);


    const [tempAccount, setTempAccount] = useState({
        FirstName: "",
        MiddleName: "",
        LastName: "",
        PhoneNumber: "",
        SchoolID: "",
        DOB: "",
    }  as AccountSchema);

    const [isSaving, setIsSaving] = useState(false);
    
    const handleNextPage = () => {
        if (page === 1) {
            return;
        }
        setPage(page + 1);
    }

    const handlePreviousPage = () => {
        if (page === 0) {
            return;
        }
        setPage(page - 1);
    }

    useEffect(() => {
        if (tempAccount.FirstName && tempAccount.LastName && tempAccount.DOB && tempAccount.PhoneNumber.length === 10 && tempAccount.PhoneNumber.match(/^[0-9]+$/)) {
            setAccountFilled(true);
        } else {
            setAccountFilled(false);
        }
    }, [tempAccount]);

    const getSelectedStyling = (selected: boolean) => {
        return selected ? "bg-blue-300" : "bg-white";
    }

    // const handleSetupUser = async () => {
    //     await createPermission(Roles.User);
    //     await refreshAccount();
    // }

    // const handleSetupTutor = async () => {
    //     await createPermission(Roles.Tutor);
    //     await refreshAccount();
    // }

    const handleSave = async () => {
        setIsSaving(true);
        if (permission.Role === Roles.Tutor) {
            await CreateTutorAccount(tempAccount).catch(
                (error) => {
                    setNewToast({ title: "Error Saving Account", message: error.message, toastType: "error" });
                }
            );
        } else if (permission.Role === Roles.User) {
            await CreateUserAccount(tempAccount).catch(
                (error) => {
                    setNewToast({ title: "Error Saving Account", message: error.message, toastType: "error" });
                }
            );
        }
        await refreshAccount().catch((error) => {
            setNewToast({ title: "Error Saving Account", message: error.message, toastType: "error" });
        });
    }

    if (!userLoggedIn) {
        navigate('/login', { replace: true });
        return <></>;
    } else if (account.FirstName) {
        navigate('/account', { replace: true });
        return <></>;
    }
    return (
        <>
            <main className={"flex flex-1 self-center place-content-center place-items-center page-hp m-auto"}>
                {
                    page === 0 ?
                    <>
                        <div className="flex flex-col w-[60%] text-gray-600 section-box gap-2 max-w-[1000px]">
                        {/* {showPermissionSetup && <PermissionSetup setupUser={handleSetupUser} setupTutor={handleSetupTutor} />} */}
                        {permission.Role === Roles.Tutor && <TutorSetup tempAccount={tempAccount} setTempAccount={setTempAccount} />}
                        {permission.Role === Roles.User && <UserSetup tempAccount={tempAccount} setTempAccount={setTempAccount} />}
                            <div className="flex flex-row-reverse px-4">
                            {accountFilled ? 
                                <button onClick={handleNextPage} className="primary-button">Next</button>
                                :
                                <button className="primary-button bg-blue-300 hover:bg-blue-300" disabled>Next</button>
                            }
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className="flex flex-col text-gray-600 space-y-5 p-4 section-box items-center min-w-[1300px]">
                        <SelectSchool />
                        <div className="grow flex flex-row-reverse px-4">
                            <button onClick={handleSave} className="primary-button mx-2">Save</button>
                            <button onClick={handlePreviousPage} className="primary-button mx-2">Previous</button>
                        </div>
                        {isSaving && <div>Saving...</div>}
                        </div>
                    </>
                }
            </main>
        </>
    );

    function SelectSchool() {
        return (
            <>
                <p className="text-base m-4">
                    Please select your school from the list below.
                </p>
                <div className="grid w-full gap-4 p-4 grid-cols-[repeat(auto-fill,minmax(150px,400px))] m-auto">
                    <div className={"hover:bg-blue-300 cursor-pointer rounded-md " + getSelectedStyling("" === tempAccount.SchoolID)} onClick={() => setTempAccount({ ...tempAccount, SchoolID: "" })}>
                        <SchoolTag />
                    </div>
                    {schools.map((school, index) => 
                    <div key={index} className={"hover:bg-blue-300 cursor-pointer rounded-md " + getSelectedStyling(school.Id === tempAccount.SchoolID)} onClick={() => setTempAccount({ ...tempAccount, SchoolID: school.Id })}>
                        <SchoolTag school={school} imageUrl={schoolImages.find(img => img.SchoolId === school.Id)?.Image}/>
                    </div>
                    )}
                </div>
            </>
        );
    }
}

function TutorSetup({ tempAccount, setTempAccount }: { tempAccount: AccountSchema, setTempAccount: (tempAccount: AccountSchema) => void }) {
    return (
        <>
            <h1 className="text-base text-center font-bold align-middle mb-4">Tutor Setup</h1>
            <p className="text-sm m-4">
                Please fill out the following information to complete your account setup.
            </p>
            <div className="grid grid-col-1 px-4">
                <Textbox label={"First Name"} name={nameofAccountSchemaFirstName} defaultValue={tempAccount.FirstName} onValueChange={(e) => setTempAccount({ ...tempAccount, FirstName: e.target.value })}></Textbox>
                <Textbox label={"Middle Name"} name={nameofAccountSchemaMiddleName} defaultValue={tempAccount.MiddleName ?? ""} onValueChange={(e) => setTempAccount({ ...tempAccount, MiddleName: e.target.value })}></Textbox>
                <Textbox label={"Last Name"} name={nameofAccountSchemaLastName} defaultValue={tempAccount.LastName} onValueChange={(e) => setTempAccount({ ...tempAccount, LastName: e.target.value })}></Textbox>
                <Textbox label={"Phone"} name={nameofAccountSchemaPhoneNumber} defaultValue={tempAccount.PhoneNumber} onValueChange={(e) => setTempAccount({ ...tempAccount, PhoneNumber: e.target.value })}></Textbox>
                <DateBox label={"DOB"} name={nameofAccountSchemaDOB} defaultValue={tempAccount.DOB} onValueChange={(e) => setTempAccount({ ...tempAccount, DOB: e.target.value })}></DateBox>
            </div>
            
        </>
    );
}

function UserSetup({ tempAccount, setTempAccount }: { tempAccount: AccountSchema, setTempAccount: (tempAccount: AccountSchema) => void }) {
    return (
        <>
            <h1 className="text-base text-center font-bold align-middle mb-4">Student Setup</h1>
            <p className="text-sm m-4">
                Please fill out the following information to complete your account setup.
            </p>
            <div className="grid grid-col-1 px-4">
                <Textbox label={"First Name"} name={nameofAccountSchemaFirstName} defaultValue={tempAccount.FirstName} onValueChange={(e) => setTempAccount({ ...tempAccount, FirstName: e.target.value })}></Textbox>
                <Textbox label={"Middle Name"} name={nameofAccountSchemaMiddleName} defaultValue={tempAccount.MiddleName ?? ""} onValueChange={(e) => setTempAccount({ ...tempAccount, MiddleName: e.target.value })}></Textbox>
                <Textbox label={"Last Name"} name={nameofAccountSchemaLastName} defaultValue={tempAccount.LastName} onValueChange={(e) => setTempAccount({ ...tempAccount, LastName: e.target.value })}></Textbox>
                <Textbox label={"Phone"} name={nameofAccountSchemaPhoneNumber} defaultValue={tempAccount.PhoneNumber} onValueChange={(e) => setTempAccount({ ...tempAccount, PhoneNumber: e.target.value })}></Textbox>
                <DateBox label={"DOB"} name={nameofAccountSchemaDOB} defaultValue={tempAccount.DOB}  onValueChange={(e) => setTempAccount({ ...tempAccount, DOB: e.target.value })}></DateBox>
            </div>
        </>
    );
}

// function PermissionSetup({ setupUser, setupTutor }: { setupUser: () => void, setupTutor: () => void }) {
//     return (
//         <>
//             <h1 className="text-base text-center font-bold align-middle mb-4">Setup</h1>
//             <p className="text-sm m-4">
//                 Hi, sorry we weren't able to determine your role. Please select your role below.
//             </p>
//             <button className="primary-button" onClick={setupUser}>Parent/Student</button>
//             <button className="primary-button" onClick={setupTutor}>Tutor</button>
//         </>
//     );
// }